import React from 'react';
import { FaEye, FaCheckCircle, FaTimesCircle, FaClock } from 'react-icons/fa';

function ApplicationTable({ applications, onViewDetail, onApprove, onReject, selectedIds, onToggleSelect, onToggleSelectAll }) {
  const hasSelection = !!selectedIds;
  const getStatusBadge = (status) => {
    const badges = {
      pending:  { icon: <FaClock />,        text: 'Gözləyən',    style: { backgroundColor: '#FFF3E0', color: '#F57C00' } },
      approved: { icon: <FaCheckCircle />,  text: 'Təsdiqləndi', style: { backgroundColor: '#E8F5E9', color: '#2E7D32' } },
      rejected: { icon: <FaTimesCircle />,  text: 'Rədd edildi', style: { backgroundColor: '#FFEBEE', color: '#C62828' } },
    };
    return badges[status] || badges.pending;
  };

  const formatDate = (date) => new Date(date).toLocaleDateString('az-AZ', {
    day: '2-digit', month: '2-digit', year: 'numeric',
  });

  return (
    <div style={styles.tableContainer}>
      <table style={styles.table}>
        <thead>
          <tr style={styles.headerRow}>
            {hasSelection && (
              <th style={styles.th}>
                <input
                  type="checkbox"
                  checked={applications.length > 0 && selectedIds.size === applications.length}
                  onChange={onToggleSelectAll}
                />
              </th>
            )}
            <th style={styles.th}>#</th>
            <th style={styles.th}>Növ</th>
            <th style={styles.th}>Ad</th>
            <th style={styles.th}>VÖEN</th>
            <th style={styles.th}>Email</th>
            <th style={styles.th}>Sahibi</th>
            <th style={styles.th}>Müqavilə</th>
            <th style={styles.th}>Status</th>
            <th style={styles.th}>Tarix</th>
            <th style={styles.th}>Əməliyyatlar</th>
          </tr>
        </thead>
        <tbody>
          {applications.map((app, index) => {
            const badge = getStatusBadge(app.status);
            const isChain = app.is_chain === true;
            return (
              <tr key={app.id} style={styles.row}>
                {hasSelection && (
                  <td style={styles.td}>
                    <input
                      type="checkbox"
                      checked={selectedIds.has(app.id)}
                      onChange={() => onToggleSelect(app.id)}
                    />
                  </td>
                )}
                <td style={styles.td}>{String(index + 1).padStart(3, '0')}</td>

                {/* Növ */}
                <td style={styles.td}>
                  <span style={{
                    padding: '3px 9px', borderRadius: 20, fontSize: 11, fontWeight: 700, whiteSpace: 'nowrap',
                    background: isChain ? '#EDE9FE' : '#FFF7E6',
                    color: isChain ? '#6D28D9' : '#92400E',
                  }}>
                    {isChain ? '🏢 Filial' : '☕ Tək Kafe'}
                  </span>
                </td>

                {/* Ad */}
                <td style={styles.td}>
                  <strong>{app.company_name}</strong>
                  {app.city && <div style={{ fontSize: 12, color: '#999', marginTop: 2 }}>{app.city}</div>}
                </td>

                <td style={styles.td}><span style={styles.voen}>{app.voen}</span></td>
                <td style={styles.td}>{app.email}</td>

                {/* Sahibi */}
                <td style={styles.td}>
                  <div style={{ fontSize: 13 }}>{app.representative_name || '—'}</div>
                  {app.representative_phone && (
                    <div style={{ fontSize: 12, color: '#999' }}>{app.representative_phone}</div>
                  )}
                </td>

                {/* Müqavilə */}
                <td style={styles.td}>
                  {app.contract_accepted
                    ? <span style={{ color: '#2E7D32', fontWeight: 700, fontSize: 13 }}>✅ Qəbul edilib</span>
                    : <span style={{ color: '#999', fontSize: 13 }}>— Gözləyir</span>
                  }
                </td>

                {/* Status */}
                <td style={styles.td}>
                  <span style={{ ...styles.statusBadge, ...badge.style }}>
                    {badge.icon}<span style={{ marginLeft: 5 }}>{badge.text}</span>
                  </span>
                </td>

                <td style={styles.td}>{formatDate(app.created_at)}</td>

                {/* Əməliyyatlar */}
                <td style={styles.td}>
                  <div style={styles.actions}>
                    <button onClick={() => onViewDetail(app)} style={styles.btnView} title="Ətraflı">
                      <FaEye />
                    </button>
                    {app.status === 'pending' && (
                      <>
                        <button onClick={() => onApprove(app)} style={styles.btnApprove} title="Təsdiqlə">
                          <FaCheckCircle /> Təsdiqlə
                        </button>
                        <button onClick={() => onReject(app)} style={styles.btnReject} title="Rədd et">
                          <FaTimesCircle /> Rədd et
                        </button>
                      </>
                    )}
                    {app.status === 'approved' && <span style={styles.approvedLabel}>✅ Təsdiqlənib</span>}
                    {app.status === 'rejected' && <span style={styles.rejectedLabel}>❌ Rədd edilib</span>}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {applications.length === 0 && (
        <div style={styles.noData}><p>Heç bir müraciət tapılmadı</p></div>
      )}
    </div>
  );
}

const styles = {
  tableContainer: { backgroundColor: '#fff', borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', overflow: 'auto' },
  table: { width: '100%', borderCollapse: 'collapse', minWidth: 1200 },
  headerRow: { backgroundColor: '#F8F9FA' },
  th: { padding: '13px 14px', textAlign: 'left', fontSize: 12, fontWeight: 'bold', color: '#666', textTransform: 'uppercase', borderBottom: '2px solid #E0E0E0', whiteSpace: 'nowrap' },
  row: { borderBottom: '1px solid #F0F0F0' },
  td: { padding: '13px 14px', fontSize: 14, color: '#1A1A2E' },
  voen: { fontFamily: 'monospace', fontSize: 12, backgroundColor: '#F8F9FA', padding: '3px 7px', borderRadius: 4, color: '#666' },
  statusBadge: { display: 'inline-flex', alignItems: 'center', gap: 5, padding: '5px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600 },
  actions: { display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' },
  btnView: { padding: '7px 11px', backgroundColor: '#2196F3', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14, display: 'flex', alignItems: 'center' },
  btnApprove: { display: 'flex', alignItems: 'center', gap: 4, padding: '7px 11px', backgroundColor: '#4CAF50', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: 600 },
  btnReject:  { display: 'flex', alignItems: 'center', gap: 4, padding: '7px 11px', backgroundColor: '#F44336', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: 600 },
  approvedLabel: { fontSize: 13, color: '#4CAF50', fontWeight: 600 },
  rejectedLabel: { fontSize: 13, color: '#F44336', fontWeight: 600 },
  noData: { padding: 40, textAlign: 'center', color: '#999' },
};

export default ApplicationTable;
